export const INITIALPROGRESS = 25;
export const STUDENT_BIO = "Student Bio";
export const STUDENT = "Student";
export const PARENT = "Parent";
export const PAYMENT = "Payment";
export const STUDENT_HISTORY = "Student History";
export const DELETE_STUDENT = "Delete Student";
export const STUDENTTABORDER = [
  STUDENT_BIO,
  STUDENT,
  PARENT,
  STUDENT_HISTORY,
  PAYMENT,
  DELETE_STUDENT,
];
export const ADD_STUDENTTABORDER = [STUDENT, PARENT, PAYMENT];
export const ADMISSION_FORWARD_TABS = ["Student", "Payment"];
export const PAYMENT_DUE_NOTIFICATIN = "Payment Due";
export const HOLIDAY = "Holiday";
export const SUBJECTS_LIST = [
  {
    value: PAYMENT_DUE_NOTIFICATIN,
    label: PAYMENT_DUE_NOTIFICATIN,
  },
  {
    value: HOLIDAY,
    label: HOLIDAY,
  },
];

// DISCOUNT TYPES
export const STAFF = "Staff";
export const FULL_PAYMENT = "Full Payment";
export const TWIN = "Twins";
export const REFERENCE = "Reference";

export const DISCOUNTTYPE = [
  { label: STAFF, value: STAFF },
  { label: FULL_PAYMENT, value: FULL_PAYMENT },
  { label: TWIN, value: TWIN },
  { label: REFERENCE, value: REFERENCE },
];
export const REFREE = ["Sanjay", "Swati", "Sanjot", "Sanmit"];
export const STAFFDISC = 10;
export const FIXEDDISC = 500;
export const PER_PAGE = 20;
// PAYMENT MODES
export const CASH = "Cash";
export const CHEQUE = "Cheque";
export const ONLINE = "Online";
export const SEND_PAYMENT_LINK_MOTHER = "Send-Payment-Link-Mother";
export const SEND_PAYMENT_LINK_FATHER = "Send-Payment-Link-Father";
export const PAYMODES = [
  CASH,
  CHEQUE,
  ONLINE,
  SEND_PAYMENT_LINK_MOTHER,
  SEND_PAYMENT_LINK_FATHER,
];

export const PAYMODE_TYPE = [
  { label: "Cash", value: "Cash" },
  { label: "Cheque", value: "Cheque" },
  { label: "Online", value: "Online" },
  {
    label: "Send payment link to Father",
    value: "Send-Payment-Link-Father",
  },
  {
    label: "Send payment link to Mother",
    value: "Send-Payment-Link-Mother",
  },
];

export const ADMISSION = "Admission";
export const ADMISSION_FORWARD = "Admission Forward";
export const PAYMENT_DUE = "Payment_Due";
export const PAYMENT_FOR_DRESS = "Payment For Dress";
export const STUDENT_FEE = "Student Fee";
export const PAYMENT_PENDING = "Payment Pending";

export const CLASS_NAME = "Class Room";
export const CLASS_GROUP = "Class Group";
export const BRANCH = "Branch";
export const CLASS_ROOM = "ClassRoom";
export const STUDENTS_GROUP = "Students Group";
export const EDIT_ACTION = "Edit";

export const EMAIL_TYPE = "Email-Parent Login";
export const SMS_TYPE = "SMS";

export const NOTIFICATION_TYPES = [
  {
    value: EMAIL_TYPE,
    label: EMAIL_TYPE,
  },
  {
    value: SMS_TYPE,
    label: SMS_TYPE,
  },
];

export const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

export const PAYMENT_DUE_TEMPLATE = `Mr %{name}% kindly note that your payment of %{dueAmount}% installment for tuition fees is delayed. It's a request to kindly pay the dues before the said date and avoid any additional charges.`;

export const APPORVED = "Approved";
export const REJECTED = "Rejected";

export const CHEQUE_STATUS = [
  { label: APPORVED, value: APPORVED },
  { label: REJECTED, value: REJECTED },
];

export const INITIATE_PAYMENT = "Initiate Payment";
export const PAYMENT_FAILED = "Payment Failed";
export const PAYMENT_COMPLETED = "Payment Completed";
export const SETTLE_STUDENT = "Settle Student";
export const PARTIAL_PAYMENT = "Partial Payment";
